// src/components/shared/ChatBox/ChatBox.tsx
import {
  Flex,
  Image
} from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { forwardRef } from "react";

// src/components/shared/ChatBox/ChatLink.tsx
import { Link, Icon } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { jsx, jsxs } from "react/jsx-runtime";
var ChatLink = ({
  label = "Chat with a licensed agent",
  icon,
  questionName
}) => {
  const { snowplow } = useSnowplowContext();
  const handleClick = () => {
    snowplow?.trigger("helpChatLinkClicked", { label: questionName });
    if (window?.zE) {
      window.zE("messenger", "show");
      window.zE("messenger", "open");
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "mobius-chatbox__chat-link", children: [
    icon && /* @__PURE__ */ jsx(Icon, { fixedWidth: true, icon, title: "Start live chat" }),
    /* @__PURE__ */ jsx(Link, { onClick: handleClick, children: /* @__PURE__ */ jsx("span", { children: label }) })
  ] });
};

// src/components/shared/ChatBox/AvatarData.ts
var DEFAULT_AVATAR = "data:image/webp;base64,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";

// src/components/shared/ChatBox/ChatBox.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var ChatBoxComponent = forwardRef((props, ref) => {
  const {
    elementType: Element = "div",
    children,
    componentName,
    position = "center",
    avatarSrc = DEFAULT_AVATAR,
    avatarAlt = "",
    ...otherProps
  } = props;
  const classes = classNames(
    "mobius",
    "mobius-chatbox",
    `mobius-chatbox--${position}`,
    otherProps.className
  );
  const { variant } = otherProps;
  return /* @__PURE__ */ jsx2(
    Element,
    {
      ref,
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: classes,
      children: /* @__PURE__ */ jsxs2("div", { className: "mobius-chatbox__grid", children: [
        /* @__PURE__ */ jsx2("div", { className: "mobius-chatbox__avatar-container", children: /* @__PURE__ */ jsx2(
          Image,
          {
            className: "mobius-chatbox__avatar",
            src: avatarSrc,
            alt: avatarAlt
          }
        ) }),
        /* @__PURE__ */ jsx2("div", { className: "mobius-chatbox__message", children: /* @__PURE__ */ jsx2(
          Flex,
          {
            flexDirection: "column",
            gap: "xs",
            className: "mobius-chatbox__inner",
            children
          }
        ) })
      ] })
    }
  );
});
ChatBoxComponent.displayName = "ChatBox";
var ChatBox = Object.assign(ChatBoxComponent, {
  ChatLink
});

export {
  ChatBox
};
